import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col } from 'reactstrap';
import { QRCodeSVG } from 'qrcode.react'; // Updated import
import image from '../../../assets/images/profilecomponent.jpg';
import { useContext } from 'react';
import { AuthContext } from '../../../pages/ExtraPages/AuthProvider';
import axios from 'axios';

const LeftSideContent = ({ profileData }) => {
  console.log('Profile data in LeftSideContent:', profileData);
  const { user } = useContext(AuthContext);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://api.starmarketapi.online/login_firebase/user-role/${user.uid}`
        )
        .then((response) => {
          setUserRole(response.data.role); // Assuming response.data contains the user role
        })
        .catch((error) => {
          console.error('Error fetching user role:', error);
        });
    }
  }, [user]);

  const getUserRole = (userRole) => {
    console.log('User role in LeftSideContent:', userRole);
    switch (userRole) {
      case 'boat_inspector':
        return 'Boat Inspector';
      case 'buyer':
        return 'Buyer';
      case 'boat_owner':
        return 'Boat Owner';
      case 'courier':
        return 'Courier';
      case 'processing_plant':
        return 'Processing Plant';

      default:
        return 'Unknown Role';
    }
  };

  // QR Code content
  const qrCodeText = user
    ? `${user.uid},${profileData.firstName} ${profileData.lastName}`
    : 'No user data available';

  return (
    <React.Fragment>
      <Col
        lg={3}
        className="d-flex justify-content-center"
      >
        <Card
          className="profile-sidebar shadow-lg rounded-2xl"
          style={{
            width: '312px',
            height: '600px',
            margin: '0 auto',
            padding: '10px',
          }}
        >
          <div className="background-div">
            <div
              style={{
                backgroundImage: `url(${image})`,
                width: '284px',
                height: '91px',
                backgroundSize: 'cover',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
              }}
            ></div>
            <CardBody className="p-4">
              <div
                className="text-center pb-4 border-bottom"
                style={{ marginTop: '-50px' }}
              >
                <div
                  style={{
                    width: '100px',
                    height: '100px',
                    marginLeft: '-10px',
                    marginRight: 'auto',
                    marginTop: '-60px',
                  }}
                >
                  {profileData.profileImage ? (
                    <div className="image-preview-container">
                      <img
                        src={profileData.profileImage}
                        alt="Profile Preview"
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '2px solid #e9ecef',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="image-placeholder mt-2 d-flex align-items-center justify-content-center"
                      style={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '50%',
                        backgroundColor: '#f1f3f5',
                        border: '2px dashed #ced4da',
                        color: '#6c757d',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        textAlign: 'center',
                      }}
                    >
                      No Image
                    </div>
                  )}
                </div>
                <div
                  className="mb-4"
                  style={{ width: '150px', float: 'right', marginTop: '12px' }}
                >
                  <h5
                    className="mb-1 fw-bold"
                    style={{
                      fontSize: '16px',
                      textAlign: 'left',
                      marginTop: '-70px',
                    }}
                  >
                    @{profileData.firstName} {profileData.lastName}
                  </h5>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: '14px', textAlign: 'left' }}
                  >
                    {getUserRole(userRole)}
                  </p>
                </div>
              </div>

              <div className="mt-4 border-bottom pb-4">
                {/* <h5
                  className="fs-17 fw-bold mb-3"
                  style={{ fontFamily: 'poppins' }}
                >
                  Profile QR Code
                </h5> */}
                <div
                  className="qr-code-container d-flex justify-content-center"
                  // style={{
                  //   backgroundColor: '#ffffff',
                  //   padding: '10px',
                  //   borderRadius: '8px',
                  //   border: '2px solid #e9ecef',
                  //   boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  // }}
                >
                  <QRCodeSVG
                    value={qrCodeText}
                    size={160}
                    level="H"
                    includeMargin={true}
                    imageSettings={{
                      src:
                        profileData.profileImage ||
                        'https://api.starmarketapi.online/favicon.ico', // Fallback to favicon
                      height: 24,
                      width: 24,
                      excavate: true,
                    }}
                    aria-label="QR code containing user ID and name"
                  />
                </div>
                <p
                  className="text-muted text-center mt-2 mb-0"
                  style={{ fontSize: '12px', fontFamily: 'poppins' }}
                >
                  Scan to view user details
                </p>
              </div>

              <div className="mt-4">
                <h5
                  className="fs-17 fw-bold mb-3"
                  style={{ fontFamily: 'poppins' }}
                >
                  Contacts
                </h5>
                <ul className="list-unstyled mb-0">
                  <li className="d-flex align-items-center mb-2">
                    <p className="text-muted mb-0">{profileData.email}</p>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <p className="text-muted mb-0">
                      {profileData.contactNumber}
                    </p>
                  </li>
                  <li className="d-flex align-items-center">
                    <p className="text-muted mb-0">{profileData.address}</p>
                  </li>
                </ul>
              </div>
            </CardBody>
          </div>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeftSideContent;
